/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/guards/app.guards.condition.ts.
 */
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {AppConditionsService} from '../services/app.conditions.service';
import {Condition} from '../modules/admin/model/condition';
import {AppConfigService} from '../services/app.config.service';
import {AppAsyncTimeout} from '../helpers/app.asyncTimeout';

/**
 * Zweck: Beschreibt class AppGuardsCondition und ihren Daten- oder Funktionsvertrag.
 */
@Injectable()
export class AppGuardsCondition  {
  conditions: Condition[];
  url_before_redirect = '';

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private router: Router, private svc: AppConditionsService, private cfg: AppConfigService) {
    svc.open_conditions.subscribe(cs => {
      this.conditions = cs;
    });
  }

  private test(route: ActivatedRouteSnapshot, rtsnap: RouterStateSnapshot, observer) {
    if (this.conditions) {
      if (this.conditions.length == 0) {
        observer.next(true);
        observer.complete();
      } else {
        let match = false;
        let matchedCondition = null;
        this.conditions.some(c => {
          if (!match && c.path_regexes) {
            c.path_regexes.some(regex => {
              regex = regex.replace(new RegExp('\/', 'g'), '\\/');
              const rregex = new RegExp(regex);

              if (!match && rtsnap.url.toString().match(rregex)) {
                match = true;
                matchedCondition = c;
                return true;
              } else {
                return false;
              }
            });
          } else if (!match) {
            if (!c.path_regexes || (c.path_regexes && c.path_regexes.length == 0)) {
              match = true;
              matchedCondition = c;
              return true;
            } else {
              return false;
            }
          }
          if (match) {
            return true;
          } else {
            return false;
          }
        });

        if (match) {
          this.url_before_redirect = rtsnap.url.toString();
          this.router.navigateByUrl('/check-conditions/' + matchedCondition.matchcode);

        } else {
          observer.next(true);
          observer.complete();
        }
      }
    } else {
      AppAsyncTimeout.setTimeout(() => {
        this.test(route, rtsnap, observer);
      }, 10);
    }
  }

/**
 * Beschreibt Methode canActivate und ihren Rückgabevertrag.
 */
  canActivate(route: ActivatedRouteSnapshot, rtsnap: RouterStateSnapshot): Observable<boolean> {
    return new Observable((observer) => {
      this.test(route, rtsnap, observer);
    });

  }

/**
 * Beschreibt Methode canActivateChild und ihren Rückgabevertrag.
 */
  canActivateChild(route: ActivatedRouteSnapshot, rtsnap: RouterStateSnapshot): Observable<boolean> {
    return new Observable((observer) => {
      this.test(route, rtsnap, observer);
    });
  }
}
